import { render } from "./SecurityText.vue?vue&type=template&id=824f85aa&scoped=true&ts=true"
import script from "./SecurityText.vue?vue&type=script&lang=ts"
export * from "./SecurityText.vue?vue&type=script&lang=ts"

import "./SecurityText.vue?vue&type=style&index=0&id=824f85aa&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-824f85aa"]])

export default __exports__